module.exports = __webpack_public_path__ + "static/img/12.0107104f.jpeg";